import { render, staticRenderFns } from "./SensitiveAttrInput.vue?vue&type=template&id=2039caba&scoped=true"
import script from "./SensitiveAttrInput.vue?vue&type=script&lang=js"
export * from "./SensitiveAttrInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039caba",
  null
  
)

export default component.exports